<template>
  <div>
    <v-toolbar flat color="white">
      <b>Our Offer</b>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="dealLenders"
      :search="search"
      :rows-per-page-items="[{'text':'All','value':-1},5,10,25]"
      v-bind:pagination.sync="pagination"
      expand
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
          <td>{{ props.item.lender_position_number }}</td>
          <td><span class="font-size">{{ props.item.lender_offer_amount | currency }}</span></td>
           <td>
            <span class="font-size">{{ props.item.lender_payback_amount | currency }}</span>
          </td>
          <td>{{ props.item.lender_term }}</td>
          <td>
            <span class="font-size">
              {{ props.item.lender_payment | currency}}
              <strong>{{ props.item.lender_payment_type }}</strong>
            </span>
          </td>
          <td>
            <span class="font-size">
              <b>{{ caculateWithholdAverage(props.item.lender_payment,props.item.lender_payment_type )}}%</b>
            </span>
          </td>
          <td>
            <span class="font-size">{{props.item.name}}</span>
          </td>
          <td>
            <span class="font-size">{{ formatDate(props.item.created_at) }}</span>
          </td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card color="grey lighten-3">
          <table class="table table-striped">
            <tr>
              <th>
                ISO Notification Message:
                <span v-html="props.item.offer_notify_note"></span>
              </th>
              <th>
                Internal Notes:
                <span v-html="props.item.offer_note"></span>
              </th>
              <th></th>
            </tr>
          </table>
        </v-card>
      </template>
      <template slot="no-data">
        <p>No data</p>
      </template>

      <template
        slot="pageText"
        slot-scope="{ pageStart, pageStop }"
      >From {{ pageStart }} to {{ pageStop }}</template>
    </v-data-table>
    <br />
  </div>
</template>
<script>
import fcs_helper from "../../helpers/fcs_helper";
import moment from "moment";
export default {
  mixins: [fcs_helper],
  data: () => ({
    pagination: { sortBy: "created_at", descending: true, rowsPerPage: -1 },
    expand: false,
    search: "",
    headers: [
      { text: "Position", value: "lender_position_number", align: "left" },
      { text: "Offer Amount", value: "lender_offer_amount", align: "left" },
      { text: "Payback Amount", value: "lender_payback_amount", align: "left" },
      { text: "Term(days)", value: "lender_term", align: "left" },
      { text: "Payment", value: "mca_daily_payment", align: "left" },
      { text: "Withhold", value: "mca_withold", align: "left" },
      { text: "Lender", value: "lender_id", align: "left" },
      { text: "Funding Date", value: "mca_date", align: "left" }
    ]
  }),
  methods: {
    formatDate(date){
      return moment(date, "MM/DD/YYYY, h:mma")
    }
  }
};
</script>

<style>
  .v-toolbar__content{
   height:34px !important; 
   margin-left:20px;
  }
  
  
</style>

<style scoped>
.font-size {
  font-size: 13px !important;
}
</style>
